import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl:
    process.env.REACT_APP_BACKEND_URL ||
    process.env.REACT_APP_API_URL ||
    "https://app.krush.in/api",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.token || localStorage.getItem("token");
    if (token) headers.set("x-auth-token", token);
    return headers;
  },
});

export const calendarApi = createApi({
  reducerPath: "calendarApi",
  baseQuery,
  tagTypes: ["Calendar"],
  endpoints: (builder) => ({
    getMyCalendarEvents: builder.query({
      query: (params) => ({ url: "/calendar", params }),
      providesTags: ["Calendar"],
      transformResponse: (res) => res?.events || [],
    }),

    createCalendarEvent: builder.mutation({
      query: (body) => ({ url: "/calendar", method: "POST", body }),
      invalidatesTags: ["Calendar"],
    }),

    updateCalendarEvent: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/calendar/${id}`, method: "PUT", body }),
      invalidatesTags: ["Calendar"],
    }),

    deleteCalendarEvent: builder.mutation({
      query: (id) => ({ url: `/calendar/${id}`, method: "DELETE" }),
      invalidatesTags: ["Calendar"],
    }),
  }),
});

export const {
  useGetMyCalendarEventsQuery,
  useCreateCalendarEventMutation,
  useUpdateCalendarEventMutation,
  useDeleteCalendarEventMutation,
} = calendarApi;
